"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoMessageWrapper = exports.Wrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.Wrapper = styled_components_1.default.div `
  width: 100%;
  height: 100%;
  border-bottom: 1px solid ${colors_1.GREY1};
  border-right: 1px solid ${colors_1.GREY1};
`;
exports.InfoMessageWrapper = styled_components_1.default.div `
  margin-top: 10px;
  font-family: SwegonBrown;
  color: ${colors_1.GREY3};
  font-size: 12px;
  font-weight: 400;
`;
//# sourceMappingURL=SoundValuesTable.styles.js.map